import { Link } from "react-router-dom";
import { AppStoreBadge, GooglePlayBadge } from "./AppBadges";

const COL_PRODUCT = [
  { l: "Features", h: "#features" },
  { l: "Pricing", h: "#pricing" },
  { l: "Multi-Location", h: "#multi-location" },
  { l: "FAQ", h: "#faq" },
];
const COL_COMPANY = [
  { l: "Contact", t: "/contact" },
  { l: "Support", t: "/support" },
];
const COL_LEGAL = [
  { l: "Privacy", t: "/privacy" },
  { l: "Terms", t: "/terms" },
];

const Column = ({ title, children }) => (
  <div>
    <h4
      className="text-[12px] font-semibold uppercase tracking-[0.12em] mb-4"
      style={{ color: "var(--lux-gold)" }}
    >
      {title}
    </h4>
    <ul className="space-y-3">{children}</ul>
  </div>
);

const Item = ({ children }) => (
  <li className="text-[14px]" style={{ color: "var(--lux-text-2)" }}>
    {children}
  </li>
);

const LandingFooter = () => (
  <footer
    className="border-t pt-16 pb-8"
    style={{ background: "#060608", borderColor: "var(--lux-border)" }}
  >
    <div className="max-w-[1200px] mx-auto px-5 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-10 mb-12">
        <div className="col-span-2">
          <img src="/logo.png" alt="Fieldz AI" className="h-9 object-contain mb-4" />
          <p className="text-[14px] max-w-sm mb-5 leading-[1.7]" style={{ color: "var(--lux-text-2)" }}>
            The all-in-one operating system for field service businesses. Schedule, dispatch, invoice, and grow.
          </p>
          <div className="flex items-center gap-3">
            <a href="https://apps.apple.com/us/app/fieldz-ai/id6759849207" target="_blank" rel="noopener noreferrer" data-testid="footer-appstore-link">
              <AppStoreBadge size="sm" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.fieldzai.app" target="_blank" rel="noopener noreferrer" data-testid="footer-playstore-link">
              <GooglePlayBadge size="sm" />
            </a>
          </div>
        </div>

        <Column title="Product">
          {COL_PRODUCT.map((x) => (
            <Item key={x.l}>
              <a href={x.h} className="hover:text-[var(--lux-gold)] transition-colors">{x.l}</a>
            </Item>
          ))}
        </Column>

        <Column title="Company">
          {COL_COMPANY.map((x) => (
            <Item key={x.l}>
              <Link to={x.t} className="hover:text-[var(--lux-gold)] transition-colors">{x.l}</Link>
            </Item>
          ))}
        </Column>

        <Column title="Legal">
          {COL_LEGAL.map((x) => (
            <Item key={x.l}>
              <Link to={x.t} className="hover:text-[var(--lux-gold)] transition-colors">{x.l}</Link>
            </Item>
          ))}
        </Column>
      </div>

      {/* Gold gradient hairline divider */}
      <div
        className="h-px mb-7"
        style={{
          background: "linear-gradient(90deg, transparent 0%, rgba(201,168,76,0.30) 50%, transparent 100%)",
        }}
      />

      <p className="text-center text-[12px]" style={{ color: "var(--lux-text-3)" }}>
        © 2026 Fieldz AI. All rights reserved.
      </p>
    </div>
  </footer>
);

export default LandingFooter;
